export default {"src":"/_next/static/media/Empty.fdcf1853.svg","height":148,"width":200,"blurWidth":0,"blurHeight":0};